import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";
import { TAG_COLOR_CLASSES } from "./TagChip";
import { LEAD_TAG_COLORS, type LeadTagColor } from "../../../../agent/src/core/leadTag/types";

const TAG_COLOR_LABELS: Record<LeadTagColor, string> = {
  purple: "Morado",
  blue: "Azul",
  teal: "Verde azulado",
  green: "Verde",
  amber: "Ámbar",
  red: "Rojo",
  pink: "Rosado",
  gray: "Gris",
};

type TagColorSwatchesProps = {
  value: LeadTagColor;
  onChange: (color: LeadTagColor) => void;
  labelledBy: string;
  className?: string;
};

const TagColorSwatches = ({ value, onChange, labelledBy, className }: TagColorSwatchesProps) => (
  <RadioGroup
    aria-labelledby={labelledBy}
    value={value}
    onValueChange={(next) => onChange(next as LeadTagColor)}
    className={cn("grid w-fit grid-cols-4 gap-3 md:grid-cols-8 md:gap-2", className)}
  >
    {LEAD_TAG_COLORS.map((option) => (
      <RadioGroupItem
        key={option}
        value={option}
        aria-label={TAG_COLOR_LABELS[option]}
        className={cn(
          "size-11 border-2 border-transparent data-[state=checked]:border-current md:size-10",
          TAG_COLOR_CLASSES[option]
        )}
      />
    ))}
  </RadioGroup>
);

export default TagColorSwatches;
